import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { getThemeAttributes, getThemeContainerAttributes } from '../theme-utils/index.esm.js';
const ThemeContext = React.createContext(undefined);
const EGDSThemeProvider = props => {
  const {
    children,
    isColorThemeContainer
  } = props;
  let {
    config: value
  } = props;
  /*
   The following mapping is necessary to ensure the legacy color props i.e. `config.lightMode` and `config.darkMode` are correctly mapped to the new color prop structure i.e. `config.color.lightMode` and `config.color.darkMode`.
  */
  value = {
    ...value,
    color: {
      ...value.color,
      ...(value?.lightMode && {
        lightMode: value.lightMode
      }),
      ...(value?.darkMode && {
        darkMode: value.darkMode
      }),
      ...(isColorThemeContainer && {
        isColorThemeContainer
      })
    }
  };
  // Remove legacy color props
  delete value.lightMode;
  delete value.darkMode;
  return jsx(ThemeContext.Provider, {
    value: value,
    children: value?.color?.isColorThemeContainer || value?.spacing?.spacingTheme ? jsx("section", {
      ...getThemeContainerAttributes({
        config: value
      }),
      children: children
    }) : children
  });
};
const useTheme = () => {
  const context = React.useContext(ThemeContext);
  // In order to implement theming, please wrap your component tree with the EGDSThemeProvider
  return context ? getThemeAttributes(context) : {};
};
export { EGDSThemeProvider, ThemeContext, useTheme };